import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { IonItem, IonGrid, IonRow, IonCol, IonImg, IonIcon } from '@ionic/react';
import { bedOutline, star, starOutline } from 'ionicons/icons';
import { Constants } from '../../defines/Constants';
import { FormatDate, FormatTime, MealPlans } from '../../defines/Functions';
import FlightDetails from './modals/FlightDetails';
import FlightRules from './modals/FlightRules';
import HotelDetails from './modals/HotelDetails';
import ResultsCustomText from './modals/ResultsCustomText';
import FlightHotelChangeFlight from './modals/FlightHotelChangeFlight';
import HotelRooms from './modals/HotelRooms';
import CurrencyFormat from 'react-currency-format';
import moment from 'jalali-moment';
import './FlightHotelCard.css';
import planeImg from '../../assets/images/flight-card-plane.svg';
import eyeImg from '../../assets/images/eye.svg';
import waiterImg from '../../assets/images/waiter.svg';
import judgeImg from '../../assets/images/judge.svg';

interface Props {
    hotelData: any,
    flightData: any,
    id: number,
    flightHotelDefines: any,
    roomStays: any,
    hotelRoom?: any,
    codeParentCallback: Function,
    expireTime?: any,
    activeFlightParentCalback: Function
}
const FlightHotelCard = (props: Props) => {
    const location = useLocation();
    const currentPage = location.pathname;
    const [activeFlight, setActiveFlight] = useState(props.hotelData.flight);
    useEffect(() => {
        setActiveFlight(props.hotelData.flight);
    }, [props.hotelData.flight])
    let dateStart: any = moment(props.flightHotelDefines.all.dates.departure).format("X");
    let dateEnd: any = moment(props.flightHotelDefines.all.dates.arrival).format("X");
    let dateDiff = Math.round((dateEnd - dateStart) / (60 * 60 * 24));
    let passengersCount = 0;
    props.flightHotelDefines.all.rooms.forEach((item: any) => {
        passengersCount += item.adults + item.childs;
    });
    let customFlightDefines = {
        targetName: props.flightHotelDefines.targetName,
        cabinClass: props.flightHotelDefines.cabinClass
    }
    const hotelCode = props.hotelData.basicPropertyInfo.hotelCode;
    let hotelRoomsData = {
        correlationId: props.hotelData.basicPropertyInfo.hotelCodeContext,
        hotelCode: props.hotelData.basicPropertyInfo.hotelCode,
        startDate: props.flightHotelDefines.all.dates.departure,
        endDate: props.flightHotelDefines.all.dates.arrival,
        cityName: props.flightHotelDefines.all.to.city_name,
        countryName: props.flightHotelDefines.all.to.country_code,
        citizenCountryName: props.flightHotelDefines.all.from.country_code,
        rooms: props.flightHotelDefines.all.rooms
    };
    let ResultsCustomTextData = {
        fromCode: props.flightHotelDefines.all.from.code,
        toCode: props.flightHotelDefines.all.to.code
    }
    const handleActiveFlightCallback = (childData: any) => {
        props.activeFlightParentCalback(childData);
    }
    let hotelRoomsItemObj = {
        id: props.id,
        data: props.hotelData,
        hotelDefines: props.flightHotelDefines,
        roomStays: props.roomStays,
        expireTime: props.expireTime
    }
    return (
        <IonItem className="flight-hotel-card-item" lines="none">
            <IonGrid>
                <IonRow className="row-1">
                    <IonCol size="6" className="col-1">
                        <IonImg src={props.hotelData.hotelImage} alt={props.hotelData.hotelName} />
                    </IonCol>
                    <IonCol size="6" className="col-2 ion-text-center">
                        <h5>
                            {props.hotelData.hotelName}
                        </h5>
                        <span>
                            {[...Array(5)].map((_, index) =>
                                index + 1 <= props.hotelData.basicPropertyInfo.award[0].rating ?
                                    <IonIcon icon={star} key={'index' + index} />
                                    :
                                    <IonIcon icon={starOutline} key={'index' + index} />
                            )}
                        </span>
                        <HotelDetails
                            hotelCode={hotelCode}
                            data={hotelRoomsData}
                            item={props}
                            activeFlight={activeFlight}
                            type="flightHotel"
                            hotelData={props.hotelData}
                            flightData={props.flightData}
                            flightHotelDefines={props.flightHotelDefines}
                        />
                    </IonCol>
                </IonRow>
                {activeFlight.airItinerary !== undefined &&
                    activeFlight.airItinerary.originDestinationOptions.originDestinationOption.map((item: any, key: number) =>
                        <IonRow className="row-flight" key={'index' + key}>
                            <IonCol size="2" className="col-1 ion-text-center">
                                <IonImg src={Constants.airlines + item.flightSegment[0].operatingAirline.code + '.png'} />
                                <span>
                                    {item.flightSegment[0].tpaextensions.any[0].airlinePersian ? (
                                        item.flightSegment[0].tpaextensions.any[0].airlinePersian
                                    ) : (
                                        item.flightSegment[0].operatingAirline.companyShortName
                                    )}
                                </span>
                            </IonCol>
                            <IonCol size="3" className="col-2 ion-text-center">
                                <h5>
                                    {FormatTime(item.flightSegment[0].departureDateTime, "hh:mm")}
                                </h5>
                                <span>
                                    {item.flightSegment[0].tpaextensions.any[0].departureCityPersian ? (
                                        item.flightSegment[0].tpaextensions.any[0].departureCityPersian
                                    ) : (
                                        item.flightSegment[0].tpaextensions.any[0].departureCity
                                    )}
                                </span>
                            </IonCol>
                            <IonCol size="4" className="col-3 ion-text-center">
                                {customFlightDefines.targetName !== 'Domestic' &&
                                    <span>
                                        {item.flightSegment.length === 1 ? (
                                            'بدون توقف'
                                        ) : (
                                            item.flightSegment.length - 1 + ' - توقف'
                                        )}
                                    </span>
                                }

                                {customFlightDefines.targetName === 'Domestic' && item.flightSegment[0].tpaextensions.any[0].aircraftName &&
                                    <span className="aircraftName">
                                        {item.flightSegment[0].tpaextensions.any[0].aircraftName}
                                    </span>
                                }

                                <IonImg src={planeImg} />
                                <span>
                                    {FormatDate(item.flightSegment[0].departureDateTime, 'jD jMMMM')}
                                </span>
                            </IonCol>
                            <IonCol size="3" className="col-4 ion-text-center">
                                <h5>
                                    {FormatTime(item.flightSegment[item.flightSegment.length - 1].arrivalDateTime, "hh:mm")}
                                </h5>
                                <span>
                                    {item.flightSegment[item.flightSegment.length - 1].tpaextensions.any[0].arrivalCityPersian ? (
                                        item.flightSegment[item.flightSegment.length - 1].tpaextensions.any[0].arrivalCityPersian
                                    ) : (
                                        item.flightSegment[item.flightSegment.length - 1].tpaextensions.any[0].arrivalCity
                                    )}
                                </span>
                            </IonCol>
                        </IonRow>
                    )}
                <IonRow className="row-2">
                    {currentPage !== '/flightHotel/reservation' &&
                        <IonCol size="6" className="col-1">
                            <span>هزینه ی {dateDiff} شب برای {passengersCount} نفر</span>
                            <b>
                                {activeFlight.airItineraryPricingInfo !== undefined &&
                                    <CurrencyFormat value={props.hotelData.price[0].amountAfterTax + activeFlight.airItineraryPricingInfo.itinTotalFare[0].equivFare[0].amount} displayType={'text'} thousandSeparator={true} suffix={' ریال'} />
                                }
                            </b>
                        </IonCol>
                    }
                    <IonCol size={currentPage !== '/flightHotel/reservation' ? '6' : '12'} className="col-2">
                        {currentPage === '/flightHotel/reservation' ?
                            <div className="dates">
                                <b>تاریخ رفت</b>
                                <span>
                                    از {moment(props.flightHotelDefines.all.dates.departure).locale('fa').format('dddd D MMMM YYYY')}
                                    ({props.flightHotelDefines.all.dates.departure})
                                </span>
                                <b>تاریخ برگشت</b>
                                <span>
                                    تا {moment(props.flightHotelDefines.all.dates.arrival).locale('fa').format('dddd D MMMM YYYY')}
                                    ({props.flightHotelDefines.all.dates.arrival})
                                </span>
                            </div>
                            :
                            <HotelRooms
                                data={hotelRoomsData}
                                item={hotelRoomsItemObj}
                                closeHotelMap={() => { }}
                                expireTime={props.expireTime}
                                type="flightHotel"
                                hotelData={props.hotelData}
                                flightData={props.flightData}
                                activeFlight={activeFlight}
                                flightHotelDefines={props.flightHotelDefines}
                            />
                        }
                        {currentPage !== '/flightHotel/reservation' &&
                            <FlightHotelChangeFlight data={props.flightData} activeFlight={activeFlight} activeFlightParentCallback={handleActiveFlightCallback} />
                        }
                    </IonCol>
                    {currentPage === '/flightHotel/reservation' &&
                        props.hotelRoom !== undefined &&
                        <IonCol size="12" className="col-3">
                            <b>اتاق ها</b>
                            {props.hotelRoom.map((item: any, index: number) =>
                                <span key={"index" + index}>
                                    <IonIcon icon={bedOutline} />
                                    {item.rms.roomTypes.roomType[0].tpaextensions !== undefined && item.rms.roomTypes.roomType[0].tpaextensions.any[0].persianRoomType ?
                                        item.rms.roomTypes.roomType[0].tpaextensions.any[0].persianRoomType
                                        :
                                        item.rms.roomTypes.roomType[0].roomType
                                    } - {MealPlans(item.rms.roomRates.roomRate[0].ratePlanID)}
                                </span>
                            )}
                        </IonCol>
                    }
                </IonRow>
                <IonRow className="row-3">
                    <IonCol size="4" className="ion-text-center col-1" style={{ fontSize: '12px', color: '#333' }}>
                        <IonIcon icon={eyeImg} />
                        <FlightDetails data={activeFlight} flightDefines={customFlightDefines} searchType="roundtrip" />
                    </IonCol>
                    <IonCol size="4" className="ion-text-center col-2" style={{ fontSize: '12px', color: '#333' }}>
                        <IonIcon icon={waiterImg} />
                        <ResultsCustomText data={ResultsCustomTextData} />
                    </IonCol>
                    <IonCol size="4" className="ion-text-center col-2" style={{ fontSize: '12px', color: '#333' }}>
                        <IonIcon icon={judgeImg} />
                        <FlightRules data={activeFlight} flightDefines={customFlightDefines} />
                    </IonCol>
                </IonRow>
            </IonGrid>
        </IonItem>
    );
};
export default FlightHotelCard;